// @flow

import React from 'react';
export function HomeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5547 3.16795C10.2188 2.94402 9.7812 2.94402 9.4453 3.16795L3.8906 6.87108C3.3342 7.24201 3 7.86648 3 8.53518V15C3 16.1046 3.89543 17 5 17H7C7.55228 17 8 16.5523 8 16V12H12V16C12 16.5523 12.4477 17 13 17H15C16.1046 17 17 16.1046 17 15V8.53518C17 7.86648 16.6658 7.24202 16.1094 6.87108L10.5547 3.16795Z" />
    </svg>
  );
}
